// fileDownloadService.js

const mimeTypes = {
  xlsx: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  xls: "application/vnd.ms-excel",
  csv: "text/csv",
  pdf: "application/pdf",
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  txt: "text/plain",
  json: "application/json",
  zip: "application/zip",
};

const getMimeType = (filename) => {
  const ext = filename.split(".").pop().toLowerCase();
  return mimeTypes[ext] || "application/octet-stream";
};

export const downloadBase64File = (base64String, filename = "download") => {
  try {
    const binary = atob(base64String.replace(/^data:.*;base64,/, ""));
    const bytes = new Uint8Array(binary.length);

    for (let i = 0; i < binary.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }

    const blob = new Blob([bytes], { type: getMimeType(filename) });

    const link = document.createElement("a");
    link.href = URL.createObjectURL(blob);
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    URL.revokeObjectURL(link.href);
  } catch (err) {
    console.error("File download failed:", err);
  }
};